'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '220 220 584 584' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M224 384l288 288 288-288h-576z' })
    ));
};